/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The confirmation ids.
 * @export
 * @interface ConfirmationId
 */
export interface ConfirmationId {
    /**
     * The expedia confirmation id.
     * @type {string}
     * @memberof ConfirmationId
     */
    expedia?: string;
    /**
     * The property confirmation id.
     * @type {string}
     * @memberof ConfirmationId
     */
    property?: string;
}

/**
 * Check if a given object implements the ConfirmationId interface.
 */
export function instanceOfConfirmationId(value: object): value is ConfirmationId {
    return true;
}

export function ConfirmationIdFromJSON(json: any): ConfirmationId {
    return ConfirmationIdFromJSONTyped(json, false);
}

export function ConfirmationIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmationId {
    if (json == null) {
        return json;
    }
    return {
        
        'expedia': json['expedia'] == null ? undefined : json['expedia'],
        'property': json['property'] == null ? undefined : json['property'],
    };
}

export function ConfirmationIdToJSON(json: any): ConfirmationId {
    return ConfirmationIdToJSONTyped(json, false);
}

export function ConfirmationIdToJSONTyped(value?: ConfirmationId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expedia': value['expedia'],
        'property': value['property'],
    };
}

